<h2 mat-dialog-title class="text-xl font-semibold text-gray-900 mb-2">Assign Parking Space to Group</h2>

<div mat-dialog-content class="space-y-4">
    <div class="bg-gray-50 p-3 rounded-lg">
        <p class="text-sm font-medium text-gray-700">Group: <span class="text-gray-900">{{ group.name }}</span></p>
        <p class="text-sm text-gray-600">Role: <span class="font-medium">{{ group.role }}</span></p>
    </div>

    @if (isLoading()) {
    <div class="flex items-center justify-center py-6">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="ml-3 text-gray-600">Loading parking spaces...</span>
    </div>
    } @else if (availableSpaces().length === 0) {
    <div class="text-center py-6 text-gray-500">
        <p>All parking spaces are already assigned to this group.</p>
    </div>
    } @else {
    <mat-form-field appearance="fill" class="w-full">
        <mat-label>Select Parking Space</mat-label>
        <mat-select [value]="selectedSpaceId()" (valueChange)="selectedSpaceId.set($event)" [disabled]="isAssigning()">
            <mat-option value="">-- Select a parking space --</mat-option>
            @for (space of availableSpaces(); track space.id) {
            <mat-option [value]="space.id">
                {{ space.name || 'Unnamed Space' }}
                @if (space.address?.firstAddressLine) {
                <span class="text-xs text-gray-500"> — {{ space.address?.firstAddressLine }}</span>
                }
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }

    @if (isAssigning()) {
    <div class="flex items-center gap-2 text-gray-600 text-sm">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Assigning parking space...</span>
    </div>
    }
</div>

<div mat-dialog-actions class="flex gap-3 pt-4">
    <button mat-button (click)="onCancel()" [disabled]="isAssigning()" class="flex-1">Cancel</button>
    <button mat-raised-button color="primary" (click)="onAssign()"
        [disabled]="!selectedSpaceId() || isAssigning() || availableSpaces().length === 0" class="flex-1">
        @if (!isAssigning()) { Assign } @else { Assigning... }
    </button>
</div>